import { createContext } from 'react';

export const AlertsActionContext = createContext({
  isActionInProgress: false,
  setIsActionInProgress: () => null,
});
